import { render, staticRenderFns } from "./cgList.vue?vue&type=template&id=0864b362&"
import script from "./cgList.vue?vue&type=script&lang=js&"
export * from "./cgList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports